import Divider from "@mui/material/Divider";
import { Box, Switch } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import FormField from "layouts/pages/account/components/FormField";

import React, { useEffect, useState } from "react";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { application } from "globals/endpoints";
import MDSnackbar from "components/MDSnackbar";
import loggerFactory from "globals/logger/logger-factory";
import CTLNotification from "application/components/CTLNotification";

import { useMaterialUIController } from "context";

function BasicInfo() {
  const [controller] = useMaterialUIController();
  const { profileStatus, darkMode } = controller;
  const digitsOnly = (value) => {
    return !value || /^\d+$/.test(value);
  };

  const componentName = "uc.settings";
  const [tempData, setTempData] = useState("");
  const initialValues = {};
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    faxNumber: Yup.string().test("Digits only", "digits only", digitsOnly),
    // phoneOffice: Yup.string()
    //   .test("Digits only", "digits only", digitsOnly)
    //   .required("Required"),
    extension: Yup.string()
      .test("Digits only", "digits only", digitsOnly)
      .required("Required"),
    phoneHome: Yup.string().test("Digits only", "digits only", digitsOnly),
    mobileNumber: Yup.string().test("Digits only", "digits only", digitsOnly),
    cfa: Yup.string().test("Digits only", "digits only", digitsOnly),
    cfb: Yup.string().test("Digits only", "digits only", digitsOnly),
    cfna: Yup.string().test("Digits only", "digits only", digitsOnly),
    fm: Yup.string().test("Digits only", "digits only", digitsOnly),

    ecfa: Yup.string().test("Digits only", "digits only", digitsOnly),
    ecfb: Yup.string().test("Digits only", "digits only", digitsOnly),
    ecfna: Yup.string().test("Digits only", "digits only", digitsOnly),
    vm: Yup.string().test("Digits only", "digits only", digitsOnly),
  });

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    if (profileStatus.profileStatus === 1) {
      setNotify({
        isOpen: true,
        message: "Click On Save Button To Save The Profile ",
      });
    }
  }, [profileStatus]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,

    onSubmit: (values) => {
      let dataToSubmit = {
        customerAccount: {
          id: tempData.id,
          firstName: values.firstName,
          lastName: values.lastName,
          emailId: values.emailId,
          faxNumber: values.faxNumber,
          phoneOffice: String(values.extension),
          extension: values.extension,
          phoneHome: values.phoneHome,
          mobileNumber: values.mobileNumber,
          company: values.company,
          designation: values.designation,
          addressOne: values.addressOne,
          addressTwo: values.addressTwo,
        },
        extensionRange: {
          dnd: values.dnd,
          local: values.local,
          intercom: values.intercom,
          std: values.std,
          isd: values.isd,
          cfa: values.cfa,
          cfb: values.cfb,
          cfna: values.cfna,
          fm: values.fm,

          ecfa: values.ecfa,
          ecfb: values.ecfb,
          ecfna: values.ecfna,
          vm: values.vm,
        },
      };
      loggerFactory.debug(componentName, "Data To Submit", dataToSubmit);
      handleSaveClick(dataToSubmit);
    },
  });

  const GetUserUrl = "/customerAccount/";
  const UpdateUrl = "/customerAccount/update";

  function UserData() {
    application
      .post(GetUserUrl)
      .then((response) => {
        loggerFactory.debug(
          componentName,
          "Get Customer Data",
          response.data.data
        );
        let customerAccount = response.data.data.customerAccount;

        if (customerAccount.id) {
          response.data.data.serviceCodeModel.map((service) => {
            switch (service.serviceCode) {
              case "LOCAL":
                customerAccount.local = service.value;
                break;
              case "Intercom":
                customerAccount.intercom = service.value;
                break;
              case "STD":
                customerAccount.std = service.value;
                break;
              case "ISD":
                customerAccount.isd = service.value;
                break;
              case "DND":
                customerAccount.dnd = service.value;
                break;
              case "FM":
                customerAccount.fm = service.data;
                break;
              case "CFA":
                customerAccount.cfa = service.data;
                break;
              case "CFB":
                customerAccount.cfb = service.data;
                break;
              case "CFNA":
                customerAccount.cfna = service.data;
                break;

              case "ECFA":
                customerAccount.ecfa = service.data;
                break;
              case "ECFB":
                customerAccount.ecfb = service.data;
                break;
              case "ECFNA":
                customerAccount.ecfna = service.data;
                break;
              case "VM":
                customerAccount.vm = service.data;
                break;
            }
          });
        } else {
          customerAccount = {
            id: 0,
            firstName: AuthenticationService.getFullName(),
            lastName: AuthenticationService.getFullName(),
            emailId: "",
            faxNumber: "",
            phoneOffice: AuthenticationService.getExtensionNumber(),
            extension: AuthenticationService.getExtensionNumber(),
            phoneHome: "",
            mobileNumber: "",
            company: "",
            designation: "",
            addressOne: "",
            addressTwo: "",
            intercom: true,
            local: false,
            std: false,
            isd: false,
            dnd: false,
            cfa: "",
            cfb: "",
            cfna: "",

            ecfa: "",
            ecfb: "",
            ecfna: "",
            vm: "",
          };
        }
        setTempData(customerAccount);
      })
      .catch((response) => {
        if (response.code === "ERR_BAD_REQUEST") {
          let customerAccount = {
            id: 0,
            firstName: AuthenticationService.getFullName(),
            lastName: AuthenticationService.getFullName(),
            emailId: "",
            faxNumber: "",
            phoneOffice: AuthenticationService.getExtensionNumber(),
            extension: AuthenticationService.getExtensionNumber(),
            phoneHome: "",
            mobileNumber: "",
            company: "",
            designation: "",
            addressOne: "",
            addressTwo: "",
            intercom: true,
            local: false,
            std: false,
            isd: false,
            dnd: false,
            cfa: "",
            cfb: "",
            cfna: "",

            ecfa: "",
            ecfb: "",
            ecfna: "",
            vm: "",
          };
          setTempData(customerAccount);
        }
      });
  }
  useEffect(() => {
    UserData();
  }, []);

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="User Profile Update"
      content="User Profile Updated successfully"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="User Profile Update"
      content="Unable to update User Profile Updated. Contact Administrator"
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
    />
  );

  function handleSwitchChange(event) {
    const { name, checked } = event.target;
    formik.setFieldValue(name, checked);
    if (name === "local" && checked) {
      formik.setFieldValue("intercom", true);
    }

    if (name === "std" && checked) {
      formik.setFieldValue("local", true);
      formik.setFieldValue("intercom", true);
    }

    if (name === "isd" && checked) {
      formik.setFieldValue("std", true);
      formik.setFieldValue("local", true);
      formik.setFieldValue("intercom", true);
    }

    if (name === "intercom" && !checked) {
      formik.setFieldValue("local", false);
      formik.setFieldValue("std", false);
      formik.setFieldValue("isd", false);
    }

    if (name === "local" && !checked) {
      formik.setFieldValue("std", false);
      formik.setFieldValue("isd", false);
    }

    if (name === "std" && !checked) {
      formik.setFieldValue("isd", false);
    }
    loggerFactory.debug(componentName, "Switch Event", {
      name: event.target.name,
      checked: event.target.checked,
    });
  }

  function handleSaveClick(dataToSubmit) {
    application
      .post(UpdateUrl, dataToSubmit)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: "Successfully Save UC User Profile",
          type: "success",
          pagename: "UC Profile Setting",
        });
        UserData();
      })
      .catch((error) => {
        if (error.code === "ERR_BAD_REQUEST") {
          loggerFactory.debug(
            componentName,
            "Unable to save the user profile data.",
            error
          );
        }
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            "" +
            error.response.data.messageDetail,
          type: "error",
          pagename: "UC Profile Setting",
        });
      });
  }

  function getValues(fieldName, dataType) {
    let returnValue = null;

    if (formik.values[fieldName] != undefined) {
      returnValue = formik.values[fieldName];
    } else {
      if (tempData[fieldName]) {
        returnValue = tempData[fieldName];
        formik.setFieldValue(fieldName, returnValue);
      } else {
        switch (dataType) {
          case "boolean":
            returnValue = false;
            break;
          default:
            returnValue = "";
            break;
        }
      }
    }
    loggerFactory.debug(componentName, "Form Get Field Value ", {
      fieldName: fieldName,
      value: returnValue,
    });

    return returnValue;
  }

  const handleExtensionChange = (e) => {
    const newValue = e.target.value;
    formik.setFieldValue("extension", newValue);
    formik.setFieldValue("phoneOffice", newValue);
  };
  return (
    <>
      {tempData && (
        <form onSubmit={formik.handleSubmit}>
          {/* Header Card */}
          <Card
            sx={{
              mb: 3,
              p: 3,
              color: "white",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
              borderRadius: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 3,
              }}
            >
              <Box>
                <MDTypography variant="h3" fontWeight="bold" sx={{ mb: 1 }}>
                  User Profile Management
                </MDTypography>
                <MDTypography variant="subtitle2" sx={{ opacity: 0.9 }}>
                  Update your personal and contact information
                </MDTypography>
              </Box>
            </Box>
          </Card>
          <Card
            id="basic-info"
            sx={{
              overflow: "visible",
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
                borderBottom: darkMode ? "2px solid rgba(255, 255, 255, 0.1)" : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography variant="h4" fontWeight="bold" sx={{ color: darkMode ? "#fff" : "#333" }}>
                User Profile Configuration
              </MDTypography>
            </MDBox>
            <MDBox pb={3} px={3} sx={{ marginTop: "20px" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                  <FormField
                    name="firstName"
                    label="First Name"
                    value={getValues("firstName")}
                    onChange={formik.handleChange}
                    error={formik.errors.firstName && formik.touched.firstName}
                    success={!formik.errors.firstName}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: darkMode ? "rgba(255, 255, 255, 0.05)" : "#f8f9fa",
                        color: darkMode ? "#fff" : "#333",
                        "&:hover": {
                          backgroundColor: darkMode ? "rgba(255, 255, 255, 0.08)" : "#fff",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: darkMode ? "#fff" : "#333",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: darkMode ? "rgba(255, 255, 255, 0.2)" : "#ddd",
                      },
                    }}
                  />
                  {formik.touched.firstName && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.firstName}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Last Name"
                    name="lastName"
                    value={getValues("lastName")}
                    onChange={formik.handleChange}
                    error={formik.errors.lastName && formik.touched.lastName}
                    success={!formik.errors.lastName}
                  />
                  {formik.touched.lastName && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.lastName}
                    </MDTypography>
                  )}
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Email"
                    name="emailId"
                    value={getValues("emailId")}
                    onChange={formik.handleChange}
                    inputProps={{ type: "email" }}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Fax Number"
                    name="faxNumber"
                    value={getValues("faxNumber")}
                    onChange={formik.handleChange}
                    error={formik.errors.faxNumber && formik.touched.faxNumber}
                    success={!formik.errors.faxNumber}
                  />
                  {formik.touched.faxNumber && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.faxNumber}
                    </MDTypography>
                  )}
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Office Extension"
                    name="extension"
                    value={getValues("extension")}
                    onChange={handleExtensionChange}
                    error={formik.errors.extension && formik.touched.extension}
                    success={!formik.errors.extension}
                  />
                  {formik.touched.extension && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.extension}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Resident Number"
                    name="phoneHome"
                    value={getValues("phoneHome")}
                    onChange={formik.handleChange}
                    error={formik.errors.phoneHome && formik.touched.phoneHome}
                    success={!formik.errors.phoneHome}
                  />
                  {formik.touched.phoneHome && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.phoneHome}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Mobile Number"
                    name="mobileNumber"
                    value={getValues("mobileNumber")}
                    onChange={formik.handleChange}
                    error={
                      formik.errors.mobileNumber && formik.touched.mobileNumber
                    }
                    success={!formik.errors.mobileNumber}
                  />
                  {formik.touched.mobileNumber && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.mobileNumber}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Company Name"
                    name="company"
                    value={getValues("company")}
                    onChange={formik.handleChange}
                    inputProps={{ type: "text" }}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Designation"
                    name="designation"
                    value={getValues("designation")}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Home Address"
                    name="addressOne"
                    value={getValues("addressOne")}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    label="Office Address"
                    name="addressTwo"
                    value={getValues("addressTwo")}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Card>
          <Card
            id="2fa"
            sx={{
              overflow: "visible",
              marginTop: "20px",
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
                borderBottom: darkMode ? "2px solid rgba(255, 255, 255, 0.1)" : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography variant="h4" fontWeight="bold" sx={{ color: darkMode ? "#fff" : "#333" }}>
                Call Configuration
              </MDTypography>
            </MDBox>
            <MDBox p={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: "8px",
                      border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: darkMode
                          ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <MDTypography variant="body2" fontWeight="500" sx={{ color: darkMode ? "#e0e0e0" : "#333" }}>
                      Dial Intercom
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        fontWeight="600"
                        sx={{
                          px: 1.5,
                          py: 0.75,
                          background: getValues("intercom", "boolean")
                            ? darkMode ? "#1e3a20" : "#d4edda"
                            : darkMode ? "#3a1e1e" : "#f8d7da",
                          color: getValues("intercom", "boolean") ? "#4caf50" : "#ff6b6b",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        {getValues("intercom", "boolean") ? "Enabled" : "Disabled"}
                      </MDTypography>
                      <Switch
                        size="medium"
                        name="intercom"
                        checked={getValues("intercom", "boolean")}
                        onChange={handleSwitchChange}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#667eea",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#667eea",
                          },
                        }}
                      />
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: "8px",
                      border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: darkMode
                          ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <MDTypography variant="body2" fontWeight="500" sx={{ color: darkMode ? "#e0e0e0" : "#333" }}>
                      Dial Local
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        fontWeight="600"
                        sx={{
                          px: 1.5,
                          py: 0.75,
                          background: getValues("local", "boolean")
                            ? darkMode ? "#1e3a20" : "#d4edda"
                            : darkMode ? "#3a1e1e" : "#f8d7da",
                          color: getValues("local", "boolean") ? "#4caf50" : "#ff6b6b",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        {getValues("local", "boolean") ? "Enabled" : "Disabled"}
                      </MDTypography>
                      <Switch
                        size="medium"
                        name="local"
                        checked={getValues("local", "boolean")}
                        onChange={handleSwitchChange}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#667eea",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#667eea",
                          },
                        }}
                      />
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: "8px",
                      border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: darkMode
                          ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <MDTypography variant="body2" fontWeight="500" sx={{ color: darkMode ? "#e0e0e0" : "#333" }}>
                      Dial STD
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        fontWeight="600"
                        sx={{
                          px: 1.5,
                          py: 0.75,
                          background: getValues("std", "boolean")
                            ? darkMode ? "#1e3a20" : "#d4edda"
                            : darkMode ? "#3a1e1e" : "#f8d7da",
                          color: getValues("std", "boolean") ? "#4caf50" : "#ff6b6b",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        {getValues("std", "boolean") ? "Enabled" : "Disabled"}
                      </MDTypography>
                      <Switch
                        size="medium"
                        name="std"
                        checked={getValues("std", "boolean")}
                        onChange={handleSwitchChange}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#667eea",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#667eea",
                          },
                        }}
                      />
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: "8px",
                      border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: darkMode
                          ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <MDTypography variant="body2" fontWeight="500" sx={{ color: darkMode ? "#e0e0e0" : "#333" }}>
                      Dial ISD
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        fontWeight="600"
                        sx={{
                          px: 1.5,
                          py: 0.75,
                          background: getValues("isd", "boolean")
                            ? darkMode ? "#1e3a20" : "#d4edda"
                            : darkMode ? "#3a1e1e" : "#f8d7da",
                          color: getValues("isd", "boolean") ? "#4caf50" : "#ff6b6b",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        {getValues("isd", "boolean") ? "Enabled" : "Disabled"}
                      </MDTypography>
                      <Switch
                        size="medium"
                        name="isd"
                        checked={getValues("isd", "boolean")}
                        onChange={handleSwitchChange}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#667eea",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#667eea",
                          },
                        }}
                      />
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>

              <Divider sx={{ my: 3, borderColor: darkMode ? "rgba(255, 255, 255, 0.1)" : "#e9ecef" }} />
              
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: "8px",
                      border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: darkMode
                          ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <MDTypography variant="body2" fontWeight="500" sx={{ color: darkMode ? "#e0e0e0" : "#333" }}>
                      Do Not Disturb
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        fontWeight="600"
                        sx={{
                          px: 1.5,
                          py: 0.75,
                          background: getValues("dnd", "boolean")
                            ? darkMode ? "#1e3a20" : "#d4edda"
                            : darkMode ? "#3a1e1e" : "#f8d7da",
                          color: getValues("dnd", "boolean") ? "#4caf50" : "#ff6b6b",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        {getValues("dnd", "boolean") ? "Enabled" : "Disabled"}
                      </MDTypography>
                      <Switch
                        size="medium"
                        name="dnd"
                        checked={getValues("dnd", "boolean")}
                        onChange={handleSwitchChange}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#667eea",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#667eea",
                          },
                        }}
                      />
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <Card
            id="2fa"
            sx={{
              overflow: "visible",
              marginTop: "20px",
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
                borderBottom: darkMode ? "2px solid rgba(255, 255, 255, 0.1)" : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography variant="h4" fontWeight="bold" sx={{ color: darkMode ? "#fff" : "#333" }}>
                Call Forwarding Configuration
              </MDTypography>
            </MDBox>
            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                  <FormField
                    name="cfa"
                    label="Call Forward Always"
                    value={getValues("cfa")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.cfa && formik.touched.cfa}
                    success={!formik.errors.cfa}
                  />
                  {formik.touched.cfa && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.cfa}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="cfb"
                    label="Call Forward Busy"
                    value={getValues("cfb")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.cfb && formik.touched.cfb}
                    success={!formik.errors.cfb}
                  />
                  {formik.touched.cfb && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.cfb}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="cfna"
                    label="Call Forward No Answer"
                    value={getValues("cfna")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.cfna && formik.touched.cfna}
                    success={!formik.errors.cfna}
                  />
                  {formik.touched.cfna && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.cfna}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="fm"
                    label="Follow Me"
                    value={getValues("fm")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.fm && formik.touched.fm}
                    success={!formik.errors.fm}
                  />
                  {formik.touched.fm && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.fm}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="ecfa"
                    label="External Forward All"
                    value={getValues("ecfa")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.ecfa && formik.touched.ecfa}
                    success={!formik.errors.ecfa}
                  />
                  {formik.touched.ecfa && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.ecfa}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="ecfb"
                    label="External Forward Busy"
                    value={getValues("ecfb")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.ecfb && formik.touched.ecfb}
                    success={!formik.errors.ecfb}
                  />
                  {formik.touched.ecfb && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.ecfb}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormField
                    name="ecfna"
                    label="External Forward No Answer"
                    value={getValues("ecfna")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.ecfna && formik.touched.ecfna}
                    success={!formik.errors.ecfna}
                  />
                  {formik.touched.ecfna && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.ecfna}
                    </MDTypography>
                  )}
                </Grid>

                {/* <Grid item xs={12} sm={3}>
                  <FormField
                    name="vm"
                    label="Voicemail"
                    value={getValues("vm")}
                    onChange={formik.handleChange}
                    inputProps={{ style: { textAlign: "center" } }}
                    error={formik.errors.vm && formik.touched.vm}
                    success={!formik.errors.vm}
                  />
                  {formik.touched.vm && (
                    <MDTypography color="error" variant="caption">
                      {formik.errors.vm}
                    </MDTypography>
                  )}
                </Grid> */}
              </Grid>

              <Box display="flex" mt={3} gap={2}>
                <MDButton
                  type="submit"
                  variant="contained"
                  color="success"
                  sx={{
                    px: 3,
                    py: 1.2,
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    borderRadius: "8px",
                    textTransform: "none",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Save
                </MDButton>
              </Box>
            </MDBox>
          </Card>
        </form>
      )}
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default BasicInfo;
